export interface IBrandSettings {
  name: string
  privacyPolicyLink: string
  copyright: string
  videoThumbnail: string
}

export interface IAppSettings {
  dateFormat: string,
  parts24LoginLink: string,
  parts24HeaderLink: string,
}

export const APP_SETTINGS = {
  brandType: 'false',
  videoThumbnail: 'assets/images/bmw-logo.png',
  miniVideoThumbnail: 'assets/images/MINI_symbol_RGB_black_30px.png',
  rollsRoyceVideoThumbnail: 'assets/images/RR_Small_Logo_Black.png',
  videoThumbnailWidth: '50px',
  videoThumbnailHeight: '50px',
  paginationPageSize: 15,
  isExternal: '',
  isDealer: '',
  isBMW: '',
  isMINI: '',
  isMOTORRAD: '',
  isRollsRoyce: '',
  isAuthorized: '',
  isAdmin: '',
  isMotorradAdmin: '',
  isRollsRoyceAdmin: '',
  isBPMAdmin: '',
  isMasterAdmin: '',
  isPartAdmin: '',
  isSIBAdmin: '',
  sessionId: '',
  serviceBulletins: 'all',
  triBulletins: 'all',
  operatingFluids: 'all',
  obd: 'all',
  partsBulletin: 'all',
  techTrainingManual: 'all',
  bodyPaintManual: 'all',
  equipManual: 'all',
  toolReport: 'all',
  takataRecall: 'bulletins',
  techDocument: 'all',
  copyright: `© 2019 BMW OF NORTH AMERICA, LLC. ALL RIGHTS RESERVED`,
  //added for dealer cms api
  centerID:'',
  locationCode:'',
  dealerCode:'',
  marketCode:'',
  marketDescription:'',
  regionCode:'',
  regionDescription:'',
  bmwCopyright: '',
  miniCopyright: '',
  rollsRoyceCopyright: '',
  motorradCopyright: '',
  currentPage: '',
  mainGroupList: [
    '[0] Maintenance and General Information',
    '[1] Warranties',
    '[2] Aftersales Development',
    '[3] Technical Training',
    '[4] Tools and Equipment',
    '[5] Information Systems',
    '[6] Service Roundtable',
    '[7] Diagnosis',
    '[8] Recall Management',
    '[9] Programming/Coding ',
    '[10] TIS',
    '[11] Engine',
    '[12] Engine Electrical Systems',
    '[13] Fuel Systems',
    '[16] Fuel Supply Systems',
    '[17] Cooling System',
    '[18] Exhaust Systems',
    '[20] Engine Electrical Systems',
    '[21] Clutch',
    '[22] Engine and gearbox suspension',
    '[23] Manual Transmission',
    '[24] Automatic Transmission',
    '[25] Gear Shift Mechanism',
    '[26] Drive Shaft',
    '[27] Intermediate and Special Transmission',
    '[28] M Double-clutch Transmission with Drivelogic',
    '[31] Front Axle',
    '[32] Steering and Wheel Alignment',
    '[33] Rear Axle',
    '[34] Brakes',
    '[35] Pedals',
    '[36] Wheels and Tires',
    '[37] Special Suspension Systems',
    '[41] Body',
    '[51] Body Equipment',
    '[52] Seats',
    '[54] Special Roofs',
    '[61] General Electrical Systems',
    '[62] Instruments',
    '[63] Lights',
    '[64] Heating and Air Conditioning',
    '[65] Audio, Navigation, Information, Safety Systems',
    '[66] Driver Assistance, Remote Control Systems',
    '[67] Electric drives',
    '[71] Tools and Accessories (Engine-Chassis)',
    '[72] Safety Belts and Accessories (Body)',
    '[80] Bicycles/Bicycle Accessories',
    '[81] Books, Calendars and Collectibles',
    '[82] Lifestyle and Gift Items',
    '[84] Communication Systems',
    '[91] Individual Equipment',
    '[97] Corrosion Protection',
    '[98] Paints and Car Care Products',
    '[99] Paint Work',
    '[100] Service Roundtable'],
    motorradMainGroupList: [
      '[00] Maintenance and General Information',
      '[01] Service Operations',
      '[02] Shop Organization',
      '[04] Warranty',
      '[05] Technical Training',
      '[06] Special Tools',
      '[08] Recall Management',
      '[11] Engine',
      '[12] Engine Electrics',
      '[13] Fuel Preparation and Control',
      '[16] Fuel Supply',
      '[17] Radiator, Cooling System',
      '[18] Exhaust Systems',
      '[21] Clutch',
      '[23] Manual Gearbox',
      '[26] Drive Shaft',
      '[31] Front Axle',
      '[32] Steering',
      '[33] Rear Axle, Rear Drive',
      '[34] Brakes',
      '[35] Pedals',
      '[36] Wheels and Tires',
      '[46] Frame and mounting parts',
      '[51] Body Equipment',
      '[52] Seats and seat bench',
      '[61] General Electrical Systems',
      '[62] Instruments',
      '[63] Lights',
      '[65] Audio, Navigation, Information Systems',
      '[66] Cruise Control, Remote Control Systems',
      '[71] Parts Engine, Chassis  ',
      '[76] Apparel Product Information',
      '[77] Accessory Product Information',
      '[78] Accessory & Apparel Technical',
      '[79] Aftersales Promotions & Marketing',
      '[80] Aftersales Organization & Team',
      '[81] Parts Pricing',
      '[82] Logistics, Returns, TEC Returns',
      '[83] Misc. Aftersales',
      '[84] Bicycles/Bicycle Accessories'],
    errorMessage: ''
};
